import React from 'react'
import Tooltip from 'src/sharedComponent/tooltip'
import RadioButton from 'src/sharedComponent/button-types/radioButton'
import { Creation_Approach, Creation_Source } from 'src/constants'
import './customCellRenderer.scss'
import { CImage } from '@coreui/react-pro'
import { startIconFilled } from 'src/asset/icon'
import TagLabel from 'src/sharedComponent/tag'
import ClassicToolTip from 'src/sharedComponent/classic-tooltip'

export const customCellRenderer = (params) => {
  const { isPercentage = false } = params
  return (
    <ClassicToolTip
      placement="top"
      tipPlacement="start"
      content={params?.value ? <div className="cell_tooltip">{params?.value}</div> : 'NA'}
    >
      <div style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
        {params?.value ? (isPercentage ? params?.value + '%' : params?.value) : '-'}
      </div>
    </ClassicToolTip>
  )
}

export const dateFormatterForPipeline = (params) => {
  if (!params.value) {
    return null
  }
  const options = {
    weekday: 'short',
    year: 'numeric',
    month: 'short',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    hour12: true,
  }
  const date = new Date(params?.value)
  const formattedDate = date.toLocaleString('en-US', options)

  const [weekday, monthDay, year, time] = formattedDate.split(',')
  const [month, day] = monthDay.trim().split(' ')

  return `${day} ${month.trim()} ${year.trim()}, ${time.trim()}`
}

export const shouldCostApproachCellRenderer = (params) => {
  const creationSource =
    params.data.creation_source === Creation_Source.SKU_Management
      ? Creation_Approach.top_down
      : Creation_Approach.bottom_up
  return <div className="d-flex align-items-start">{creationSource}</div>
}

export const RadioCellRenderer = (params) => {
  const isSelected = params?.node?.selected
  return <RadioButton label="" checked={isSelected} />
}

export const modelIdsCellRenderer = (row, isShowIfaShortlistFlag = false) => {
  const value = row.value
  // const value =
  //   "39982:1,7577:1,5583:0,7430:1,38291:0,32382:1,7777:1,5683:0,7430:1,32291:0";

  if (!value) return <span>-</span>

  const models = value.split(',')
  const displayModels = (models) => (
    <div className="d-flex align-items-center gap-1 flex-wrap">
      {models.map((item, index) => {
        const [modelId, flag] = item.split(':')
        const isIFAShorlisted = isShowIfaShortlistFlag ? flag === '1' : false

        return (
          <span key={`${modelId}-${index}`} className="d-flex align-items-center">
            {isIFAShorlisted && (
              <CImage src={startIconFilled} height={17} width={17} className="me-1" />
            )}
            {modelId}
            {index < models.length - 1 ? ', ' : ''}
          </span>
        )
      })}
    </div>
  )
  if (models.length <= 3) {
    return displayModels(models)
  }

  return (
    <div className="d-flex align-items-center justify-content-between w-100 h-100 gap-2">
      <div>{displayModels(models.slice(0, 3))}</div>

      <Tooltip
        content={displayModels(models.slice(3, models.length))}
        // placement="bottom"
        // trigger="hover"
      >
        +{models.length - 3}
      </Tooltip>
    </div>
  )
}

export const extrapolatedTagCellRenderer = (params) => {
  return (
    <div className={`d-flex align-items-center h-100`}>
      {params?.data?.model_generation_type === 'EXTRAPOLATED' ? (
        <Tooltip content="Cost derived via extrapolation" placement="top">
          <TagLabel
            // id={ }
            label={params?.data?.model_generation_type}
            variant={'info'}
            type="secondary"
            visible={true}
            className={'extrapolated-cell-renderer'}
          />
        </Tooltip>
      ) : (
        <span className="ms-2">-</span>
      )}
    </div>
  )
}
